import * as _ from "lodash";
import beneficiaryTypeDelimiter from "../common/constants/beneficiaryTypeDelimiter";

var BeneficiaryTypeService = function () {
    var _beneficiaryTypes;

    return {
        setTypes: function (beneficiaryTypes) {
            _beneficiaryTypes = beneficiaryTypes.slice(0);
        },

        getTypes: function () {
            return _beneficiaryTypes;
        },

        /**
         * Set the hierarchy of beneficiary types and relationships. The relationships will
         * be children of the parent type. The input array will be mutated.
         *
         * @param   array   beneficiaryTypes    The flat array of beneficiary types and relationships
         * @returns {*}
         */
        setTypeRelationshipHierarchyFrom: function (beneficiaryTypes) {
            var children, code;

            var doesMatchCode = function (n) {
                return n.code.indexOf(code + beneficiaryTypeDelimiter) === 0;
            };

            // Iterate through the beneficiary types and pull out relationship values.
            // We recalculate the length each iteration because the array will be mutated
            // whenever relationships are found.
            for (var i = 0; i < beneficiaryTypes.length; i++) {
                code = beneficiaryTypes[i].code;

                // Pull out any type/relationship pairs that match "CODE:" of the current type
                children = _.remove(beneficiaryTypes, doesMatchCode);

                // Set the relationships as children of the beneficiary type and mark the
                // parent flag for simple filtering in the HTML
                if (children.length > 0) {
                    beneficiaryTypes[i].children = children;
                    beneficiaryTypes[i].parent = true;
                } else {
                    beneficiaryTypes[i].parent = false;
                }
            }
        }
    };
};

export default BeneficiaryTypeService;
